import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useEffect, useState } from "react"
import { Row, Col, CardBody, Card, Alert, Container } from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import { withRouter, Link } from "react-router-dom"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { loginUser } from "../../store/actions"
import profile from "assets/images/profile-img.png"
import logo from "assets/images/logo.svg"
import cookieHelper from "helpers/cookie_helper"
import { useHistory } from "react-router-dom"

const Login = props => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [isLoginType, setIsLoginType] = useState("1")

  useEffect(() => {
    if (
      localStorage.getItem("authUser") ||
      cookieHelper.getCookie("authUser")
    ) {
      history.push("/dashboard")
    }
  }, [])

  const { error } = useSelector(state => ({
    error: state.Login.error,
  }))

  // handleValidSubmit
  const handleValidSubmit = (event, values) => {
    dispatch(
      loginUser(
        { ...values, is_login: isLoginType, phone: "", country_code: "+91" },
        props.history
      )
    )
  }

  return (
    <React.Fragment>
      <MetaTags>
        <title>Login </title>
      </MetaTags>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <CardBody className="p-4">
                  <div className="text-center mb-4">
                    <Link to="/" className="d-inline-block auth-logo">
                      <div className="avatar-md profile-user-wid mb-3 d-inline-block">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt="DealToClose Logo"
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                    <h5 className="mt-2" style={{ color: "#243E79", fontWeight: "700" }}>Welcome Back!</h5>
                    <p className="text-muted">Sign in to continue to DealToClose Admin.</p>
                  </div>
                  <div className="p-2">
                    <AvForm
                      className="form-horizontal"
                      onValidSubmit={(e, v) => {
                        handleValidSubmit(e, v)
                      }}
                    >
                      {error ? <Alert color="success">{error}</Alert> : null}

                      <div className="mb-3">
                        <AvField
                          name="email"
                          label="Email"
                          value="sairam@gmail.com"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          required
                        />
                        <div className="text-end">
                          <span
                            onClick={() =>
                              setIsLoginType(isLoginType == "1" ? "0" : "1")
                            }
                          >
                            Login with otp
                          </span>
                        </div>
                      </div>

                      {isLoginType && (
                        <div className="mb-3">
                          <AvField
                            name="password"
                            label="Password"
                            value="sai@777"
                            type="password"
                            required
                            placeholder="Enter Password"
                          />
                        </div>
                      )}

                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customControlInline"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customControlInline"
                        >
                          Remember me
                        </label>
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                        >
                          Log In
                        </button>
                      </div>

                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" />
                          Forgot your password?
                        </Link>
                      </div>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  © {new Date().getFullYear()} hms. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger" /> by catchysystem
                  technologies
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
